var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 62,
    viewBox: "0 0 88 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "upload icon",
    d: "M19.8 62C8.86875 62 0 53.0737 0 42.0714C0 33.3804 5.5275 25.9902 13.2275 23.2638C13.2137 22.8902 13.2 22.5165 13.2 22.1429C13.2 9.90893 23.045 0 35.2 0C43.3538 0 50.4625 4.45625 54.2713 11.0991C56.3613 9.6875 58.8913 8.85714 61.6 8.85714C68.8875 8.85714 74.8 14.808 74.8 22.1429C74.8 23.8312 74.4837 25.4366 73.92 26.9312C81.95 28.5643 88 35.7192 88 44.2857C88 54.0701 80.1213 62 70.4 62H19.8ZM30.6625 31.9687C29.37 33.2696 29.37 35.3732 30.6625 36.6603C31.955 37.9473 34.045 37.9612 35.3237 36.6603L40.6862 31.2629V49.8214C40.6862 51.6621 42.1575 53.1429 43.9863 53.1429C45.815 53.1429 47.2863 51.6621 47.2863 49.8214V31.2629L52.6488 36.6603C53.9412 37.9612 56.0312 37.9612 57.31 36.6603C58.5887 35.3594 58.6025 33.2558 57.31 31.9687L46.31 20.8973C45.0175 19.5964 42.9275 19.5964 41.6488 20.8973L30.6488 31.9687H30.6625Z",
    fill: "#C8D7E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud_upload.03272b23bc708c4b686964df3907d21b.svg";
export { ForwardRef as ReactComponent };